export enum WizardStep {
  Step_1 = 1,
  Step_2 = 2,
}
